import React from 'react';
import classes from '../../../assets/Global.module.css';
import { ComchekBoardItem } from '../../../interfaces/comchek';
import DateOnlyFormatter from '../../../helpers/inputs/DateOnlyFormatter';

function ComchekSummary({ data }: { data: ComchekBoardItem }) {
  return (
    <>
      <div className={classes.viewGrid}>
        <div className={`${classes.attribute} ${classes.span3}`}>
          <h3>Express Check Number</h3>
          <span>{data?.expressCheckNumber}</span>
        </div>
        <div className={`${classes.attribute}`}>
          <h3>Amount</h3>
          <span>
            {data?.amount.toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
            })}
          </span>
        </div>
        <div className={`${classes.attribute}`}>
          <h3>Fee</h3>
          <span>
            {data?.fee.toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
            })}
          </span>
        </div>
        <div className={classes.attribute}>
          <h3>Balance</h3>
          <span>
            {data?.balance.toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
            })}
          </span>
        </div>
        <div className={classes.attribute}>
          <h3>Status</h3>
          <span>{data?.status ? data.status : '-'}</span>
        </div>
        <div className={`${classes.attribute} ${classes.span2}`}>
          <h3>Status Checked</h3>
          <span>
            {data?.statusChecked
              ? DateOnlyFormatter(data.statusChecked)
              : '-'}
          </span>
        </div>
        <div className={classes.attribute}>
          <h3>Used Date</h3>
          <span>
            {data?.usedDate ? DateOnlyFormatter(data.usedDate) : '-'}
          </span>
        </div>
        <div className={`${classes.attribute} ${classes.span2}`}>
          <h3>Used Location</h3>
          <span>{data?.usedLocation ? data.usedLocation : '-'}</span>
        </div>
        <div className={classes.attribute}>
          <h3>Load #</h3>
          <span>{data?.loadId ? data.loadId : '-'}</span>
        </div>
        <div className={`${classes.attribute} ${classes.span2}`}>
          <h3>Rental #</h3>
          <span>{data?.rentalId ? data.rentalId : '-'}</span>
        </div>
        <div className={classes.attribute}>
          <h3>Truck Name</h3>
          <span>{data?.truckName ? data.truckName : '-'}</span>
        </div>
        <div className={classes.attribute}>
          <h3>Trailer Name</h3>
          <span>{data?.trailerName ? data.trailerName : '-'}</span>
        </div>
        <div className={`${classes.attribute} ${classes.span3}`}>
          <h3>Driver Name</h3>
          <span>{data?.driverName}</span>
        </div>
        <div className={classes.attribute}>
          <h3>Issued On</h3>
          <span>
            {data?.issuedOn ? DateOnlyFormatter(data.issuedOn) : '-'}
          </span>
        </div>
        <div className={classes.attribute}>
          <h3>Created By</h3>
          <span>{data?.createdBy ? data.createdBy : '-'}</span>
        </div>
        <div className={classes.attribute}>
          <h3>Reason Code</h3>
          <span>{data?.reasonCode}</span>
        </div>
        <div className={classes.attribute}>
          <h3>Cancelled On</h3>
          <span>
            {data?.cancelledOn ? DateOnlyFormatter(data.cancelledOn) : '-'}
          </span>
        </div>
        <div className={classes.attribute}>
          <h3>Cancelled By</h3>
          <span>{data?.cancelledBy ? data.cancelledBy : '-'}</span>
        </div>
        <div className={`${classes.attribute} ${classes.span3}`}>
          <h3>Note</h3>
          <span>{data?.note ? data.note : '-'}</span>
        </div>
        <div className={`${classes.attribute} ${classes.span3}`}>
          <h3>Vendor</h3>
          <span>{data?.vendorName ? data.vendorName : '-'}</span>
        </div>
      </div>
    </>
  );
}

export default ComchekSummary;
